/**
 * StatusChip — issue/work status. Color is never the sole signal (icon + text + color).
 */

type Status = "todo" | "in_progress" | "in_review" | "done" | "blocked" | "at_risk";

const STYLES: Record<Status, { bg: string; fg: string; dot: string; label: string }> = {
  todo: {
    bg: "var(--surface-2)",
    fg: "var(--body-mid)",
    dot: "var(--mute)",
    label: "To do",
  },
  in_progress: {
    bg: "rgba(122,61,255,0.10)",
    fg: "#5a26d6",
    dot: "#7a3dff",
    label: "In progress",
  },
  in_review: {
    bg: "rgba(20,110,245,0.12)",
    fg: "#146ef5",
    dot: "#146ef5",
    label: "In review",
  },
  done: {
    bg: "rgba(0,215,34,0.12)",
    fg: "#047a18",
    dot: "#00d722",
    label: "Done",
  },
  blocked: {
    bg: "rgba(238,29,54,0.12)",
    fg: "#ee1d36",
    dot: "#ee1d36",
    label: "Blocked",
  },
  at_risk: {
    bg: "rgba(255,174,19,0.16)",
    fg: "#8a5b00",
    dot: "#ffae13",
    label: "At risk",
  },
};

export function StatusChip({ status }: { status: Status }) {
  const s = STYLES[status];
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: "3px 8px",
        borderRadius: 4,
        background: s.bg,
        color: s.fg,
        fontFamily: "var(--font-sans)",
        fontSize: 12.8,
        fontWeight: 550,
        whiteSpace: "nowrap",
      }}
    >
      <span
        aria-hidden="true"
        style={{ width: 6, height: 6, borderRadius: 9999, background: s.dot }}
      />
      {s.label}
    </span>
  );
}
